var map = {
	"./t4.png": "f1qa",
	"./t4_h.png": "fGPz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9msj";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab ^\.\/t4.*\.png$
// module id = 9msj
// module chunks = 1